import './invoice-grid.css';
import React, { useEffect, useRef, useState } from 'react';
import { Divider, Table, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, Form, Select, notification, Tabs } from 'antd';
import { CrrencySymbols, PlantInvoiceDetailsModel, PlantInvoiceDetailsRequest } from "@gtpl/shared-models/sale-management";
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Link, Redirect } from "react-router-dom";
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, SearchOutlined, UndoOutlined, CloseOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Invoice } from "@gtpl/pages/logistics/logistics-components/invoice"
import { EmployeeRolesEnum, UiConfig } from '@gtpl/shared-models/common-models';
import { render } from 'react-dom';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { PlantsDropDown } from '@gtpl/shared-models/masters';

export interface InvoiceGridProps { }
/* eslint-disable-next-line */

export function InvoiceGrid(props: InvoiceGridProps) {
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchedColumn, setSearchedColumn] = useState('');
  const [object, setObject] = useState(null);
  const numbers = [1, 12, 123, 1234, 12345, 123456, 1234567, 12345678, 123456789].map(String);
  const [form ] = useForm()
  const [activeTab, setActiveTab] = useState("ACTIVE");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [invoiceData, setInvoiceData] = useState<PlantInvoiceDetailsModel[]>([]);
  const [years,setYears] = useState<any[]>([])
  const [selectedInvoiceData, setSelectedInvoiceData] = useState<any>(undefined);
const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const unitsService = new UnitcodeService();
  const [unitId, setUnitId] = useState<number>(0);
  const invoiceDataService = new SaleOrderService;
  const [saleOrderIdState, setsaleOrderIdState] = useState<any>(null);
  console.log(saleOrderIdState)
const { TabPane } = Tabs;


  useEffect(() => {
  getAllInvoices();
}, [activeTab]);

  useEffect(() => {
  getAllFinancialYear();

  if (Number(localStorage.getItem('unit_id')) != 5) {
    form.setFieldsValue({ unitId: Number(localStorage.getItem('unit_id')) });
    setUnitId(Number(localStorage.getItem('unit_id')));
  }

  getAllPlants();

  if (Number(localStorage.getItem('unit_id')) != 5) {
  getAllInvoices();   
}
}, []);



  const setUpdatevalue = (rowdata) => {
    console.log(rowdata);
    setObject(rowdata.saleOrderId)

  }

  const setsaleOrderId = (rowdata) => {

    setsaleOrderIdState(rowdata)

  }
  /**
   * 
   */

  
  const getAllFinancialYear  = () => {
    invoiceDataService.getAllFinancialYear().then(res => {
      if (res.status) {
        setYears(res.data);
      } else {
        if (res.intlCode) {
          setYears([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setYears([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  const getAllPlants = () => {
    unitsService.getAllMainPlants().then((res) => {
        if (res.status) {
            setPlantData(res.data);
        } else {
            setPlantData([]);
        }
    }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
        setPlantData([]);
    })
}
  const getAllInvoices = () => {
setLoading(true);
    const reqObj = new PlantInvoiceDetailsRequest;
    const financialYear = form.getFieldValue('financialYear');
    if (financialYear) {
      reqObj.financialYear = financialYear;
    }
    reqObj.tab = activeTab;
    reqObj.unit = form.getFieldValue('unitId')
    invoiceDataService.getAllPlantInvoiceDetails(reqObj).then(res => {
      if (res.status) {
        for (const destinationData of res.data) {
          const destinationPlace = `${destinationData.country}, ${destinationData.destinationName}`;
          destinationData.country = destinationPlace
        }
        setInvoiceData(res.data);
        
      } else {
        if (res.intlCode) {
          setInvoiceData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
      setLoading(false);
    }).catch(err => {
      setInvoiceData([]);
      AlertMessages.getErrorMessage(err.message);
      setLoading(false);
    })
  }
  /**
   * 
   * @param productData 
   */

  /**
   * 
   * @param variantData 
   */

  /**
  * used for column filter
  * @param dataIndex column data index
  */
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const onFinish = (val) => {
    console.log(val);
    
    getAllInvoices()
    };
  
    const onReset = () => {
      form.resetFields();
      getAllInvoices();
    };

  //drawer related
  const closeDrawer = () => {
    setDrawerVisible(false);
  }

  //TO open the form for updation
  const openFormWithData = (viewData: PlantInvoiceDetailsModel) => {
    setDrawerVisible(true);
    console.log(viewData);
    setSelectedInvoiceData(viewData);
  }


  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '75px',
      fixed: 'left',
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: 'Invoice Date',
      dataIndex: 'invoiceDate',
      fixed: 'left',
      // responsive: ['lg'],
      sorter: (a, b) => a.invoiceDate.localeCompare(b.invoiceDate),
      sortDirections: ['descend', 'ascend'],
      render: (value, record: PlantInvoiceDetailsModel, index) => {
        return moment(record.invoiceDate).format('YYYY-MMMM-DD');
      }
    },
    {
      title: 'Invoice Number',
      dataIndex: 'invoiceNumber',
      fixed: 'left',
      // responsive: ['lg'],
      sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('invoiceNumber')
    },
    {
      title: 'Customer PO',
      dataIndex: 'saleOrderId',
      // responsive: ['lg'],
      fixed: 'left',
      sorter: (a, b) => a.saleOrderId - b.saleOrderId,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('custPoNo'),
      render: (text, rowData) => { return rowData.custPoNo }
    },
    {
      title: 'Customer Name',
      dataIndex: 'clientName',
      // responsive: ['lg'],
      sorter: (a, b) => a.clientName.localeCompare(b.clientName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('clientName')
    },
    {
      title: 'End Customer Name',
      dataIndex: 'endCustomerName',
      // responsive: ['lg'],
      sorter: (a, b) => a.endCustomerName.localeCompare(b.endCustomerName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('endCustomerName')
    },
    {
      title: 'Country',
      dataIndex: 'country',
      // responsive: ['lg'],
      sorter: (a, b) => a.country.localeCompare(b.country),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('country'),
      render: (text, data, index) => {
        return <span>{text}</span>
      }

    },

    {
      title: 'Unit',
      dataIndex: 'unitName',
      // responsive: ['lg'],
      sorter: (a, b) => a.unitName.localeCompare(b.unitName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('unitName')
    },
    {
      title: 'Total Amount',
      dataIndex: 'totalAmount',
      align: 'right',
      // responsive: ['lg'],
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('totalAmount'),
      render: (text, rowData) => { return CrrencySymbols.find(item => item.id == rowData.currency)?.symbol + ' ' + rowData.totalAmount },
    },
    {
      title: 'Exchange Rate(₹)',
      dataIndex: 'exchangeRate',
      align: 'right',
      // responsive: ['lg'],
      sorter: (a, b) => a.exchangeRate - b.exchangeRate,
      sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('exchangeRate'),
      render: (text, rowData) => { return Number(text) },


    },
    {
      title: 'FOB Value in Rs',
      dataIndex: 'fobValue',
      align: 'right',
      // responsive: ['lg'],
      sorter: (a, b) => a.totalInrAmount - b.totalInrAmount,
      sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('total_INR_amount'),
      render: (text, rowData) => { return (rowData.totalAmount > 0) ? Number((rowData.totalAmount - rowData.freightCharges - rowData.insurance) * (rowData.exchangeRate)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0 },
    },
    // {
    //   title: 'Q Certificate No',
    //   dataIndex: 'qCertificateNo',
    //   // fixed: 'left',
    //   // responsive: ['lg'],
    //   // sorter: (a, b) => a.invoiceId - b.invoiceId,
    //   // sortDirections: ['descend', 'ascend'],
    //   ...getColumnSearchProps('qCertificateNo')
    // },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (Status, rowData) => (
        <>
          {Status}

        </>
      ),
      filters: [
        {
          text: 'OPEN',
          value: "OPEN",
        },
        {
          text: 'CLOSE',
          value: "CLOSE",
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => {
        // === is not work
        return record.status === value;
      },
    },

    {
      title: `Action`,
      dataIndex: 'action',
      fixed: 'right',
      render: (text, rowData) => (
        <span>

          {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.OPERATIONS_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.OPERATIONS_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) ||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON)) &&
            (object) ? <Redirect
            to={{
              pathname: "/invoice-form",
              state: object
            }}
          /> : null}
          {activeTab === "ACTIVE" && (
            <>
          <EditOutlined className={'editSamplTypeIcon'} type="edit"
            onClick={() => {
              setUpdatevalue(rowData);

            }}
            style={{ color: '#1890ff', fontSize: '14px' }}
          />
</>
)}
          <Divider type="vertical" />
          {(saleOrderIdState) ? <Redirect to={`/invoice-detail-view/${saleOrderIdState.saleOrderId}`}
          /> : null}
          <EyeOutlined type="view"
            onClick={() => {

              // if (rowData.isActive) {
              setsaleOrderId(rowData);
            }}
            style={{ color: '#1890ff', fontSize: '14px' }}
          />
          {activeTab === "ACTIVE" && (
            <>
          <Divider type="vertical" />
           <Popconfirm
        title="Are you sure you want to cancel this order?"
        okText="Yes"
        cancelText="No"
        onConfirm={() => handleCancel(rowData)}
      >
        <CloseOutlined
          style={{ color: "red", fontSize: "14px", cursor: "pointer" }}
        />
      </Popconfirm>
      </>
)}
        </span>
      )
    }
  ];
  const handleUnit = (value) => {
  setUnitId(value)
}

const handleCancel = (rowData: any) => {
  invoiceDataService.cancelInvoice(rowData).then((res) => {
    if (res.status) {
      notification.success({
        message: "Invoice Cancelled",
        description: "The invoice has been cancelled successfully.",
      });
      setActiveTab("CANCEL");
    } else {
      notification.error({
        message: "Cancel Failed",
        description: res.internalMessage || "Something went wrong",
      });
    }
  }).catch((err) => {
    notification.error({
      message: "Error",
      description: err.message || "Server error",
    });
  });
};



  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
 const onChange = (pagination, filters, sorter, extra) => {
  setPage(pagination.current);
};

  return (
    <Card title={<span style={{ color: 'white' }}>Invoice</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}

      extra={<Link to='/invoice-form' ><span style={{ color: 'white' }} >
        {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.OPERATIONS_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
          <Button className='panel_button' >Create </Button>}
      </span></Link>}
    >

      {/* <Row gutter={40}>
        <Col>
          <Card title={'Total Invoices: ' + invoiceData.length} style={{ textAlign: 'left', width: 250, height: 41, backgroundColor: '#bfbfbf' }}></Card>
        </Col>
        <Col>
           <Card title={'Active: ' + invoiceData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active :' + invoiceData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
      </Row> */}
      <Tabs
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
        }}
      >
        <TabPane tab="Invoices" key="ACTIVE" />
        <TabPane tab="Cancelled" key="CANCEL" />
      </Tabs>

        <Form form={form} onFinish={onFinish} onValuesChange={(changed, all) => {
    if (changed.unitId !== undefined) {
        setUnitId(changed.unitId);
    }
}} layout="vertical">
          <Row gutter={16}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
        <Form.Item name="unitId"   label="Unit" rules={[{ required: false,message: 'Missing Unit' }]} >
               <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Unit"
                    allowClear
                    style={{ width: '100%' }}
                    
                    // disabled={Number(localStorage.getItem('unit_id')) != 5 ? true : false}
                >
                    {plantData.filter(dropData => dropData.plantId !== null).map((y: any) => (
                    <Select.Option key={y.plantId} value={y.plantId}>
                      {y.plantCode}
                    </Select.Option>
                  ))}
                </Select>
            </Form.Item>
          
        </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={4}>
              <Form.Item name="financialYear" label="Financial Year">
                <Select
                  showSearch
                  placeholder="Select Financial Year"
                  optionFilterProp="children"
                  allowClear
                >
                  {years.filter(year => year.financialYear !== null).map((y: any) => (
                    <Select.Option key={y.financialYear} value={y.financialYear}>
                      {y.financialYear}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col style={{marginTop:'30px'}}>
              <Form.Item >
                <Button
                  htmlType="submit"
                  type="primary"
                  style={{ width: '100px', marginRight: '10px' }}
                >
                  Get Report
                </Button>
              </Form.Item>
            </Col>
            <Col style={{marginTop:'30px'}}>
              <Form.Item >
                <Button
                  type="primary"
                  icon={<UndoOutlined />}
                  onClick={onReset}
                >
                  Reset
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <Table
          rowKey={record => record.invoiceId}
          columns={columnsSkelton}
          loading={loading}
          dataSource={invoiceData
            //   .filter(JSON.parse(localStorage.getItem('unit_id')))}
            // pagination={{
            //   onChange(current) {
            //     setPage(current);
            //   }
            // }
          }
          onChange={onChange}
          scroll={{ x: true }}
          bordered
        />
    
    </Card>
  );
}



export default InvoiceGrid;